export const apiEs = {
  datatable: {
    rowsperpage: 'Elementos por página:'
  }
};
